import ProfileComponent from "../components/cards/profile-card/profile";
import SecurityComponent from "../components/cards/profile-card/security";
import PrivacyPolicyText from "../pages/__PrivacyPolicy";
import BillingComponent from "../components/cards/profile-card/billing";
import AboutUsText from "../pages/__AboutUs";

const settingsItems = [
  { 
    item: 'Profile', 
    iconfill: 'bi bi-file-person-fill', 
    icon: 'bi bi-file-person', 
    component: ProfileComponent
  },
  { item: 'Security', iconfill: 'bi bi-shield-fill', icon: 'bi bi-shield', component: SecurityComponent },
  { item: 'Privacy', iconfill: 'bi bi-lock-fill', icon: 'bi bi-lock', component: PrivacyPolicyText },    
  { item: 'Billing', iconfill: 'bi bi-receipt-cutoff', icon: 'bi bi-receipt-cutoff', component: BillingComponent },
  { item: 'About', iconfill: 'bi bi-info-circle-fill', icon: 'bi bi-info-circle', component: AboutUsText },
];

export default settingsItems;
